<template>
  <v-row v-if="existSomeActiveChannel" class="pt-3">
    <v-col v-for="channel in channels" :key="channel.value" cols="6" class="py-0">
      <v-checkbox
        v-model="selectedOption"
        :label="channel.label"
        :value="channel.value"
        multiple
        class="my-0 py-0"
        :disabled="isTheLastActiveChannel(channel.value)"
        @change="$emit('change', $event)"
      ></v-checkbox>
    </v-col>
  </v-row>
  <v-row v-else>
    <v-col class="d-flex flex-row">
      <mf-icon fill class="mr-1" small color="marca-0">error</mf-icon>
      <p class="mb-0 subtitle-2 primary--text">Não há canais ativos</p>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'CheckboxChannels',
  props: {
    selected: {
      type: Array,
      required: false,
      default: () => [],
    },
    channels: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    existSomeActiveChannel() {
      return this.channels.length
    },
    selectedOption: {
      get() {
        return this.selected
      },
      set(value) {
        this.$emit('update:selected', value)
      },
    },
  },
  methods: {
    isTheLastActiveChannel(currentChannel) {
      if (!this.selectedOption) return false
      return this.selectedOption.includes(currentChannel) && this.selectedOption.length === 1
    },
  },
}
</script>
